export const checkFileSizeInMb = (file, maxFileSize) => {
  const fileSize = file.size;
  const fileSizeInMb = parseFloat((fileSize / (1024 * 1024)).toFixed(2));
  return fileSizeInMb > parseFloat(maxFileSize);
};
